/* eslint-disable no-underscore-dangle */
import { ACCESS_TYPE, LICENSE_TYPE } from '../constants';

export interface EnvConfig {
  API_URL: string;
  ENV: string;
  VERSION: string;
  DEFAULT_LANGUAGE: string;
  SENTRY_DSN_URL: string;
}

type HubSpotUnreadConversationCountChanges = 'unreadConversationCountChanged';
type HubSpotUnreadConversationCountChangedEvent = (
  eventType: HubSpotUnreadConversationCountChanges,
  callback: (payload?: { unreadCount?: number }) => void
) => void;
declare global {
  interface Window {
    // add your custom properties and methods
    env: EnvConfig;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PngToy: any;

    // HubSpot Chat Widget - Typing not complete:. See full API here: https://legacydocs.hubspot.com/docs/methods/conversations_api/hubspot-conversations-javascript-api
    HubSpotConversations?: {
      on: HubSpotUnreadConversationCountChangedEvent;
      off: HubSpotUnreadConversationCountChangedEvent;
      widget?: {
        open: VoidFunction;
        close: VoidFunction;
        refresh: VoidFunction;
        remove: VoidFunction;
      };
    };
  }
}

export interface IAppConfig {
  env: string;
  version: string;
  apiBaseURL: string;
  defaultLanguage: string;
  platform: string;
  defaultLicense: string;
  defaultRole: string;
  licenseTypes: Array<{ label: string; value: string }>;
  accessTypes: Array<{ label: string; value: string }>;
}

const getAPIBaseURL = () => {
  // Retrieve API url from control-panel/build-config
  if (window.env) {
    return window.env.API_URL;
  }

  // Retrieve API url from local development env file if enabled
  if (import.meta.env.REACT_APP_LOCAL_SERVICE === '1' && import.meta.env.REACT_APP_LOCAL_SERVICE_URL) {
    return import.meta.env.REACT_APP_LOCAL_SERVICE_URL;
  }

  return 'https://api.integration.corsmed.com/';
};

export const AppConfig: IAppConfig = {
  env: window.env ? window.env.ENV : 'development',
  version: window.env ? window.env.VERSION : 'v1.0.0',
  apiBaseURL: getAPIBaseURL(),
  defaultLanguage: window.env ? window.env.DEFAULT_LANGUAGE : 'en',
  platform: 'dashboard',
  defaultLicense: LICENSE_TYPE.TRIAL,
  defaultRole: ACCESS_TYPE.STUDENT,
  licenseTypes: [
    {
      label: 'Trial',
      value: LICENSE_TYPE.TRIAL,
    },
    {
      label: 'Paid',
      value: LICENSE_TYPE.PAID,
    },
    {
      label: 'Internal',
      value: LICENSE_TYPE.INTERNAL,
    },
  ],

  accessTypes: [
    {
      label: 'Admin',
      value: ACCESS_TYPE.ADMIN,
    },
    {
      label: 'Teacher',
      value: ACCESS_TYPE.TEACHER,
    },
    {
      label: 'Student',
      value: ACCESS_TYPE.STUDENT,
    },
  ],
};

export default AppConfig;
